<template>
    <div class="c_indexBox">
        <div class="ros_selBox">
            <div class="inform_tit" @click="cancel"> 
                <i class="el-icon-back myback_icon" style="vertical-align: middle;"></i> Back
            </div>
            <el-input  class="timepick_showBox" @keyup.enter.native="search" v-model="word">
                <span slot="prefix" class="time_icon_pick"></span>
            </el-input>
        </div>
        <div class="ros_selBox">
            <span class="ros_checkTit" :class="{'active1':active==1}" @click="changeType(1)">Received ({{received}})
                <span class="ros_line" :class="{'active':active==1}"></span>
            </span>
            <span class="ros_checkTit" :class="{'active1':active==2}" @click="changeType(2)">Uncollected ({{uncollected}})
                <span class="ros_line" :class="{'active':active==2}"></span>
            </span>
        </div>
        <!-- <transition name="fade-in" v-if="month"> -->
            <router-view  v-if="!loading" @accept='accept' :keyword="this.word" :status="this.active" :isSearch="this.isSearch"/>
        <!-- </transition> -->
    </div>
</template>

<script>
export default {
    data() {
        return {
            active:1,
            word:'',
            isSearch:false,
            uncollected:0,
            received:0,
            loading:false,
            month:''
        }
    },
    methods: {
        changeType(key){
            this.active=key
            this.word = ''
            this.loading=true
            if(key==1){
                this.$router.push({path:'/feeDetail/received'})
            }else{
                this.$router.push({path:'/feeDetail/uncollected'})
            }
            setTimeout(() => {
                this.loading=false
            }, 200);
        },
        cancel(){
            this.$router.push({path:'/feelist'})
        },
        search(){ 
            this.isSearch = true
            setTimeout(()=>{
                this.isSearch = false
            },200)
        },
        accept(unpay,pay){
            this.uncollected = unpay
            this.received = pay
        }
    },
    mounted() {
        let {month,uncollected,received} = this.$route.query
        this.month = month
        this.uncollected = uncollected
        this.received = received
    },
}
</script>

<style lang="scss" scoped>
    .c_indexBox{
        width: 100%;
        .rosTitBox{
            height:33px;
            font-size:24px;
            font-weight:600;
            color:rgba(255,255,255,1);
            line-height:33px;
            -webkit-text-stroke:1px rgba(255,255,255,1);
            text-stroke:1px rgba(255,255,255,1);
            margin-bottom: 39px;
        }
        .inform_tit{
            height:40px;
            font-size:14px;
            font-weight:600;
            color:rgba(255,255,255,1);
            line-height:40px;
            cursor: pointer;
            width: 150px;
        }
        .ros_selBox{
            display: flex;
            margin-bottom: 30px;
            position: relative;
            .ros_checkTit{
                // width:137px;
                cursor: pointer;
                height:28px;
                font-size:20px;
                font-weight:600;
                color:#9fa0a2;
                line-height:28px;
                position: relative;
                &:nth-child(1){
                    margin-right: 44px;
                }
            }
            .active1{
                color:rgba(255,255,255,1) !important;
            }
            .timepick_showBox{
                width: 300px;
                margin-left: auto;
                border-bottom: 2px solid #fff;
                background-color: #212429;
                height: 40px;
                align-items: center;
                display: flex;
                position: relative;
                color: #fff;
                cursor: pointer;
                .time_icon_pick{
                    position: absolute;
                    left: 0px;
                    top: 10px;
                    width: 24px;
                    height: 22px;
                    background: url('../../assets/s.png');
                    background-size: contain;
                }
            }
            .myTimeBox{
                cursor: pointer;
                position: absolute;
                opacity: 0;
                z-index: 10;
                width: 240px;
                right: 0;
            }
        }
        .ros_line{
            position: absolute;
            width: 0px;
            right: 0;
            bottom: -13px;
            height: 2px;
            border-radius: 3px;
            overflow: hidden;
            transition: all .7s;
            opacity: 0.1;
        }
        .active{
            left: 0;
            width:100%;
            background:rgba(234,55,150,1);
            opacity: 1;
        }
    }
    .fade-in-enter-active, .fade-in-leave-active {
        transition: opacity .5s ease;
    }
    .fade-in-enter, .fade-in-leave-to {
        opacity: 0;
    }
    label > * {
        pointer-events: none;
    }
</style>


// WEBPACK FOOTER //
// src/components/fee/feedetail.vue